export const getApiErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  const payload = error?.response?.data;

  if (typeof payload === 'string' && payload.trim()) return payload;
  if (payload?.message) return payload.message;
  if (payload?.error) return payload.error;
  if (error?.error) return error.error;
  if (error?.message) return error.message;

  return fallback;
};
